import { classNames } from 'shared/lib/classNames/classNames'
import cls from './IconBadge.module.scss'

export const IconBadgeTone = {
    BLUE: 'Blue',
    GRAY: 'Gray',
    GREEN: 'Green',
}

export const IconBadge = ({
    children,
    className,
    tone = IconBadgeTone.BLUE,
}) => (
    <span className={classNames(cls.Badge, { [cls[tone]]: true }, [className])}>
        {children}
    </span>
)
